import { Component, Input } from '@angular/core';
import { ChatMessage } from '../../copilot.model';
import { MarkdownComponent } from '../../../../shared/components/markdown/markdown.component';
import {SourceDisplayComponent} from '../source-display/source-display.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-user-message',
  imports: [MarkdownComponent, SourceDisplayComponent, NgIf],
  templateUrl: './user-message.component.html',
  styleUrl: './user-message.component.scss'
})
export class UserMessageComponent {

  @Input() message!: ChatMessage;

}
